import OtherPageFormat from "../components/OtherPageFormat";

const MenuPage = () => {
  return (
    <div className="bg-red-200 h-4/5">
      <OtherPageFormat title={"Menu"} />
    </div>
  );
};

export default MenuPage;
